import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA support and offline caching
// Note: Service worker only works in production builds
// Uncomment this after running 'npm run build'

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  // Disable console logs in production
  console.log = function () { };
  console.info = function () { };
  console.warn = function () { };
  console.error = function () { };

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/serviceWorker.js')
      .then((registration) => {
        // console.log('✅ Service Worker registered:', registration);
      })
      .catch((error) => {
        // console.log('❌ Service Worker registration failed:', error);
      });
  });
}


// Measure and log performance metrics
reportWebVitals((metric) => {
  // Log to console in development
  if (process.env.NODE_ENV === 'development') {
    console.log(metric);
  }
  // You can send to analytics in production
});
